var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout_box"},[_c('top-nav',{staticClass:"topNav"}),_c('div',{staticStyle:{"height":"65px"}}),_c('keep-alive',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }